import { Component, OnInit } from '@angular/core';
import { PanoramaImages } from '../../../../dtos/panoramaImages';
import { Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { MonumentDto } from '../../../../dtos/monumentDto';
import { HotSpot } from '../../../../dtos/hotSpot';
import { SiteDto } from '../../../../dtos/siteDto';
import { DomSanitizer } from '@angular/platform-browser';
import { MonumentsDataService } from '../../../remote/data-storage/monuments-data.service';

@Component({
    selector: 'app-shared-view',
    templateUrl: './shared-view.component.html',
    styleUrls: ['./shared-view.component.scss']
})
export class SharedViewComponent implements OnInit {

    constructor(private sanitizer: DomSanitizer, private monumentsDataService: MonumentsDataService) {
    }

    @Input()
    isOwner: boolean;

    @Input()
    selectedPanorama: PanoramaImages;
    @Output()
    selectedPanoramaChange: EventEmitter<PanoramaImages> = new EventEmitter<PanoramaImages>();

    @Input()
    isMonumentOpen: boolean;
    @Output()
    isMonumentOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input()
    showCompass = true;

    @Input()
    monumentView: string;
    @Output()
    monumentViewChange: EventEmitter<string> = new EventEmitter<string>();

    @Input()
    selectedMonument: MonumentDto;
    @Output()
    selectedMonumentChange: EventEmitter<MonumentDto> = new EventEmitter<MonumentDto>();

    @Input()
    fileToShare: string;

    @Input()
    panoramaHeight: string = '100vh';


    @Output()
    fileToShareChange: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    panoramaConfigurationChange: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    sitePanoramicHotspots: HotSpot[];
    @Output()
    sitePanoramicHotspotsChange: EventEmitter<HotSpot> = new EventEmitter<HotSpot>();

    @Input()
    site: SiteDto;

    @Input()
    monumentClass: string= "";

    @Input()
    guiEnabled: boolean = true;

    actionGuide = 'mouse';

    ngOnInit(): void {
    }


    toggleMonument() {
        this.isMonumentOpen = false;
        this.isMonumentOpenChange.emit(this.isMonumentOpen)
        this.selectedMonument = null;
        this.monumentView = null;
        this.monumentViewChange.emit(this.monumentView);
        this.selectedMonumentChange.emit(this.selectedMonument);
    }

    isImage(file) {
        return !file.includes('.pdf');
    }


    toggleFile() {
        this.fileToShare = null;
        this.fileToShareChange.emit(this.fileToShare);
    }

    transformPdf(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url + '#toolbar=0&embedded=true');
    }

    openMonument(monumentID, view?) {
        this.isMonumentOpen = true;
        this.monumentsDataService.getAllMonumentData()
            .subscribe((monuments) => {
                const monument = monuments.find((monument: MonumentDto) => monument.id === monumentID);
                this.selectedMonument = null;
                this.selectedMonumentChange.emit(null);

                this.isMonumentOpenChange.emit(this.isMonumentOpen);
                this.selectedMonument = monument;
                this.selectedMonumentChange.emit(monument);
                if (view) {
                    setTimeout(() => {
                        this.monumentView = view;
                        this.monumentViewChange.emit(this.monumentView);
                    })
                }
            })
    }

    handleConfigurationChange(event) {
        const hotSpot: HotSpot = event.hotSpot;
        if (hotSpot && hotSpot.hotSpotType === 'NAVIGATION') {
            if (hotSpot.panoramaComponent === 'PANORAMA') {
                this.selectedPanorama = null;
                this.selectedPanorama = this.site.panoramaImages.find((panorama) => panorama.id === hotSpot.componentID);
                setTimeout(() => {
                    this.sitePanoramicHotspots = [...this.selectedPanorama.panoramaHotSpots];
                })
            }
            if (hotSpot.panoramaComponent === 'MONUMENT') {
                this.openMonument(hotSpot.componentID);
            }
        }
    }

}
